/* eslint-disable default-case */

import _ from 'lodash'
import { Tag } from 'antd'
import { squadronHelper } from './pools'

const poolColumns = [
  {
    title: 'last name',
    dataIndex: 'last_name',
    sorter: (a, b) => {
      if (a.last_name < b.last_name) return -1
      if (a.last_name > b.last_name) return 1
      return 0
    },
    display: true
  },
  {
    title: 'first name',
    dataIndex: 'first_name',
    sorter: (a, b) => {
      if (a.first_name < b.first_name) return -1
      if (a.first_name > b.first_name) return 1
      return 0
    },
    display: true
  },
  {
    title: 'age',
    dataIndex: 'age',
    sorter: (a, b) => a.age - b.age,
    display: true
  },
  {
    title: 'demographic',
    dataIndex: 'demographic',
    sorter: (a, b) => {
      if (a.demographic < b.demographic) return -1
      if (a.demographic > b.demographic) return 1
      return 0
    },
    display: true,
    render: (value) => {
      let color = 'default'
      switch (value) {
        case 'open': {
          color = 'green'
          break
        }
        case 'ladies': {
          color = 'purple'
          break
        }
        case 'cadet': {
          color = 'blue'
        }
      }
      return (
        <Tag color={color} key={value}>
          {value?.toUpperCase()}
        </Tag>
      )
    }
  },
  {
    title: 'club',
    dataIndex: 'club',
    sorter: (a, b) => {
      if (a.club < b.club) return -1
      if (a.club > b.club) return 1
      return 0
    },
    display: true
  },
  {
    title: 'rating',
    dataIndex: 'rating',
    sorter: (a, b) => {
      if (a.rating < b.rating) return -1
      if (a.rating > b.rating) return 1
      return 0
    },
    display: true
  },
  {
    title: 'squadron',
    dataIndex: 'pool',
    sorter: (a, b) => {
      if (a.pool < b.pool) return -1
      if (a.pool > b.pool) return 1
      return 0
    },
    display: true,
    render: (value) => {
      return squadronHelper.getColor(value - 1)
    }
  }
]

const poolResultColumns = [
  {
    title: 'place',
    dataIndex: 'place',
    sorter: (a, b) => {
      if (a.place < b.place) return -1
      if (a.place > b.place) return 1
      return 0
    },
    display: true
  },
  {
    title: 'last name',
    dataIndex: 'last_name',
    sorter: (a, b) => {
      if (a.last_name < b.last_name) return -1
      if (a.last_name > b.last_name) return 1
      return 0
    },
    display: true
  },
  {
    title: 'first name',
    dataIndex: 'first_name',
    sorter: (a, b) => {
      if (a.first_name < b.first_name) return -1
      if (a.first_name > b.first_name) return 1
      return 0
    },
    display: true
  },
  {
    title: 'demo',
    dataIndex: 'demographic',
    sorter: (a, b) => {
      if (a.demographic < b.demographic) return -1
      if (a.demographic > b.demographic) return 1
      return 0
    },
    display: false,
    render: (value) => {
      let color = 'default'
      switch (value) {
        case 'open': {
          color = 'green'
          break
        }
        case 'ladies': {
          color = 'purple'
          break
        }
        case 'cadet': {
          color = 'blue'
        }
      }
      return (
        <Tag color={color} key={value}>
          {value?.toUpperCase()}
        </Tag>
      )
    }
  },
  {
    title: 'club',
    dataIndex: 'club',
    sorter: (a, b) => {
      if (a.club < b.club) return -1
      if (a.club > b.club) return 1
      return 0
    },
    display: false
  },
  {
    title: 'rating',
    dataIndex: 'rating',
    sorter: (a, b) => {
      if (a.rating < b.rating) return -1
      if (a.rating > b.rating) return 1
      return 0
    },
    display: false
  },
  {
    title: 'squad',
    dataIndex: 'pool',
    sorter: (a, b) => {
      if (a.pool < b.pool) return -1
      if (a.pool > b.pool) return 1
      return 0
    },
    display: false,
    render: (value) => {
      return squadronHelper.getColor(value - 1)
    }
  },
  {
    title: 'wins',
    dataIndex: 'victories',
    sorter: (a, b) => {
      if (a.victories < b.victories) return -1
      if (a.victories > b.victories) return 1
      return 0
    },
    display: true
  },
  {
    title: 'points',
    dataIndex: 'points',
    sorter: (a, b) => {
      if (a.points < b.points) return -1
      if (a.points > b.points) return 1
      return 0
    },
    display: true
  },
  {
    title: 'pts +',
    dataIndex: 'hitsScored',
    sorter: (a, b) => {
      if (a.hitsScored < b.hitsScored) return -1
      if (a.hitsScored > b.hitsScored) return 1
      return 0
    },
    display: false
  },
  {
    title: 'pts -',
    dataIndex: 'hitsAgainst',
    sorter: (a, b) => {
      if (a.hitsAgainst < b.hitsAgainst) return -1
      if (a.hitsAgainst > b.hitsAgainst) return 1
      return 0
    },
    display: false
  },
  {
    title: 'index',
    dataIndex: 'index',
    sorter: (a, b) => {
      if (a.index < b.index) return -1
      if (a.index > b.index) return 1
      return 0
    },
    display: false
  }
]

const finalColumns = [
  {
    title: 'Place',
    dataIndex: 'place',
    key: 'place',
    display: true
  },
  {
    title: 'Last Name',
    dataIndex: 'last_name',
    key: 'last_name',
    display: true
  },
  {
    title: 'First Name',
    dataIndex: 'first_name',
    key: 'first_name',
    display: true
  },
  {
    title: 'age',
    dataIndex: 'age',
    sorter: (a, b) => a.age - b.age,
    display: false
  },
  {
    title: 'Demographic',
    dataIndex: 'demographic',
    render: (value) => {
      let color = 'default'
      switch (value) {
        case 'open': {
          color = 'green'
          break
        }
        case 'ladies': {
          color = 'purple'
          break
        }
        case 'cadet': {
          color = 'blue'
        }
      }
      return (
        <Tag color={color} key={value}>
          {value?.toUpperCase()}
        </Tag>
      )
    },
    display: false
  },
  {
    title: 'Club',
    dataIndex: 'club',
    display: true
  },
  {
    title: 'Rating',
    dataIndex: 'rating',
    display: true
  },
  {
    title: 'Raw Tournament Points',
    dataIndex: 'tournamentPoints',
    display: false
  },
  {
    title: 'Tournament Points',
    dataIndex: 'tournamentPointsAdjusted',
    display: true
  },
  {
    title: 'Promotion',
    dataIndex: 'rankPromotion',
    display: true
  }
]

const streamOverviewColumns = [
  {
    title: 'name',
    dataIndex: 'first_name',
    render: (value, record) => {
      return `${record.first_name} ${_.first(record.last_name)}.`
    }
  },
  {
    title: 'wins',
    dataIndex: 'victories',
    render: (value, record) => {
      return `${record.stats.standard.wins}`
    }
  },
  {
    title: 'ind',
    dataIndex: 'index',
    render: (value, record) => {
      return `${record.stats.standard.for - record.stats.standard.against}`
    }
  },
  {
    title: 'honor',
    dataIndex: 'stats.honor',
    render: (value, record) => {
      return `${record.stats.honor}`
    }
  }
]

export {
  poolColumns,
  poolResultColumns,
  finalColumns,
  streamOverviewColumns
}
